<template>
  <div ref="popover" class="popover bs-tether-element bs-tether-element-attached-top bs-tether-element-attached-center bs-tether-target-attached-bottom bs-tether-target-attached-center fade bs-tether-enabled show">
       <!--style="top: 0px; left: 0px; position: absolute; transform: translateX(710.469px) translateY(671px) translateZ(0px);">-->
    <div class="popover-title">
      <div class="text-center">
        <trans-text i18nKey="ui['5_1'][15]"/>
      </div>
    </div>
    <div class="popover-content">
      <div class="form-group row mb-0" >
        <label class="col-5 col-form-label px-2"><small><trans-text i18nKey="ui['5_1'][16]"/></small></label>
        <div class="col-7">
          <input class="form-control transparent-input" type="number" value="" placeholder="123456"  v-model="input.school_code" @change="$v.input.school_code.$touch()" >
        </div>
        <p class="col-12 my-0 form-control-feedback">
          <input-feedback :validate-for-input="$v.input.school_code" type="required"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][1]"/></input-feedback>
          <input-feedback :validate-for-input="$v.input.school_code" type="number"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][2]"/></input-feedback>
          <input-feedback :validate-for-input="$v.input.school_code" type="numberLength"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][3]"/></input-feedback>

          <span class="form-control-feedback" v-if="apiErrorI18nKey"><i class="fa fa-asterisk" aria-hidden="true" ></i> <trans-text i18nKey="error['5_1'][4]"/></span>
        </p>
        <div class="col-12 form-hr">
          <hr class="">
        </div>
      </div>
      <div class="text-center">
        <button class="btn btn-danger" type="button" @click="tryForm">
          <trans-text i18nKey="ui['5_1'][17]"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'
  import {required,number,numberLength} from 'systems/validators'
  import FormPartialBase from 'extends/FormPartialBase.vue'
  import SchoolCode from 'processor/SchoolCode'

  export default {
    name:"",
    extends:FormPartialBase,
    components: {
    },
    data () {
      return {
        apiErrorI18nKey:null,
        input: {
          school_code: "",
        },
      }
    },
    validations: {
      input: {
        school_code: {
          required,
          number,
          numberLength: numberLength(8)
        },
      },
    },
    created(){

    },
    mounted(){
//      this.$nextTick(function () {
//      })

    },
    methods:{
      tryForm(e){
        //バリデーション
        if(this.$v.input.$invalid){
          this.$v.input.$touch()
          return
        }

        SchoolCode.schoolCodeActivation(this.input)
          .then((res)=>{
            if(res.status === "ng"){
              this.apiErrorI18nKey = res.apiErrorI18nKey
              return
            }
            $('html,body').animate({scrollTop: 0}, 500, 'swing');
            this.$emit('fetchOrganization')
          })
      },
    }
  }
</script>


<style lang="scss" scoped>
  .popover-title{
    font-size: .8rem;
    background-color: #fef7ea;
  }
</style>



// WEBPACK FOOTER //
// AddSchoolCodePopover.vue?6b02f18c